module.exports = __webpack_public_path__ + "img/GRIN.69dfb7e7.png";